import axios from 'axios/index';

const METHOD_POST = 'POST';
const METHOD_GET = 'GET';

class DashboardApi {
  /**
   * @param {string} url
   * @param {number} timeout
   */
  constructor (url, timeout) {
    this.url = url;
    this.timeout = timeout;
  }

  /**
   * @param {string} username
   * @param {string} password
   * @returns {Promise<*>}
   */
  async logIn(username, password) {
    const data = { username, password };

    return this.makeRequest(METHOD_POST, 'login', null, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async logOut(token) {
    return this.makeRequest(METHOD_POST, 'logout', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getClients(token) {
    return this.makeRequest(METHOD_GET, 'clients', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getDrugStats(token) {
    return this.makeRequest(METHOD_GET, `drug/prescriptions/stats`, token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async getDrugPrescriptions(token, id) {
    return this.makeRequest(METHOD_GET, `clients/${id}/prescriptions`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addDrugPrescription(token, data) {
    return this.makeRequest(METHOD_POST, `prescriptions`, token, data);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @param data
   * @returns {Promise<*>}
   */
  async updateDrugPrescription(token, prescriptionId, data) {
    return this.makeRequest(METHOD_POST, `prescriptions/${prescriptionId}`, token, data);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @returns {Promise<*>}
   */
  async archiveDrugPrescription(token, prescriptionId) {
    return this.makeRequest(METHOD_POST, `prescriptions/${prescriptionId}/archive`, token);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @returns {Promise<*>}
   */
  async restoreDrugPrescription(token, prescriptionId) {
    return this.makeRequest(METHOD_POST, `prescriptions/${prescriptionId}/restore`, token);
  }

  /**
   * @param {string} token
   * @param {number} prescriptionId
   * @returns {Promise<*>}
   */
  async deleteDrugPrescription(token, prescriptionId) {
    return this.makeRequest(METHOD_POST, `prescriptions/${prescriptionId}/delete`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getFavoritesDrugPrescriptions(token) {
    return this.makeRequest(METHOD_GET, `prescriptions/favorites`, token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async addDrugPrescriptionToFavorites(token, id) {
    return this.makeRequest(METHOD_POST, `prescriptions/${id}/favorites/add`, token);
  }

  /**
   * @param {string} token
   * @param {number} id
   * @returns {Promise<*>}
   */
  async removeDrugPrescriptionFromFavorites(token, id) {
    return this.makeRequest(METHOD_POST, `prescriptions/${id}/favorites/remove`, token);
  }

  /**
   * @param {string} token
   * @param {string} id
   * @returns {Promise<*>}
   */
  async getHealthStatus(token, id) {
    return this.makeRequest(METHOD_GET, `clients/${id}/health`, token);
  }

  /**
   * @param {string} token
   * @param data
   * @returns {Promise<*>}
   */
  async addHealthStatus(token, data) {
    return this.makeRequest(METHOD_POST, `health/status`, token, data);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getCatalogs(token) {
    return this.makeRequest(METHOD_GET, 'catalogs', token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getFormats(token) {
    return this.makeRequest(METHOD_GET, `formats`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getIngredients(token) {
    return this.makeRequest(METHOD_GET, `ingredients`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getMethods(token) {
    return this.makeRequest(METHOD_GET, `methods`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getTimes(token) {
    return this.makeRequest(METHOD_GET, `times`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getDrugs(token) {
    return this.makeRequest(METHOD_GET, `drugs`, token);
  }

  /**
   * @param {string} token
   * @returns {Promise<*>}
   */
  async getHealthElements(token) {
    return this.makeRequest(METHOD_GET, `health`, token);
  }

  /**
   * @param {string} method
   * @param {string} path
   * @param {string} token
   * @param params
   * @returns {Promise<*>}
   */
  async makeRequest(method, path, token, params) {
    const url = `${this.url}/${path}`;
    const headers = { 'Content-Type': 'application/json' };

    if (typeof token === 'string') {
      headers['Authorization'] = token;
    }

    const config = {
      method,
      url,
      responseType: 'json',
      headers,
      data: params,
      timeout: this.timeout,
    };

    const response = await axios(config);

    return response.data;
  }
}

export default DashboardApi;
